import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { LogoBig } from "@/components/Logo";

const inputCls =
  "min-h-[48px] w-full rounded-xl border border-ink/15 bg-white px-4 text-base text-ink outline-none transition-colors placeholder:text-ink/35 focus:border-forest focus:ring-2 focus:ring-forest/20";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("pc_token", data.token);
      navigate("/admin/tableau");
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Connexion impossible. Réessayez.");
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F2F8FB] px-4">
      <form onSubmit={submit} className="w-full max-w-md rounded-3xl bg-white p-8 shadow-sm ring-1 ring-ink/5 sm:p-10">
        <div className="mb-8 flex justify-center">
          <LogoBig />
        </div>
        <h1 className="mb-1 text-center font-serif text-2xl font-semibold text-ink">Espace pro</h1>
        <p className="mb-8 text-center text-sm text-ink/55">Connectez-vous pour gérer vos livraisons.</p>

        <label className="mb-4 block">
          <span className="mb-1.5 block text-sm font-semibold text-ink">E-mail</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
            data-testid="admin-email-input"
            autoComplete="email"
          />
        </label>
        <label className="mb-6 block">
          <span className="mb-1.5 block text-sm font-semibold text-ink">Mot de passe</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
            data-testid="admin-password-input"
            autoComplete="current-password"
          />
        </label>

        {error && (
          <p className="mb-4 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-red-700" data-testid="admin-login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-button"
          className="flex min-h-[52px] w-full items-center justify-center gap-2 rounded-full bg-forest text-base font-semibold text-cream transition-all duration-200 hover:bg-forest-dark disabled:opacity-60"
        >
          {loading && <Loader2 className="h-5 w-5 animate-spin" />}
          Se connecter
        </button>
        <a href="/" className="mt-5 block text-center text-sm font-medium text-ink/50 transition-colors hover:text-forest">
          ← Retour au site
        </a>
      </form>
    </div>
  );
}
